import MainImage from './MainImage'

export default MainImage;